const sizeUnits = ["GB", "MB", "KB"] as const;
type UnitType = (typeof sizeUnits)[number];

const toUnitSize = (sizeInBytes: number, unit: UnitType) => {
  switch (unit) {
    case "KB":
      return sizeInBytes / 10 ** 3;
    case "MB":
      return sizeInBytes / 10 ** 6;
    case "GB":
      return sizeInBytes / 10 ** 9;
    default:
      return sizeInBytes;
  }
};

export const parseFileSize = ({
  sizeInBytes,
  unit,
}: {
  sizeInBytes: number;
  unit?: UnitType;
}) => {
  if (unit !== undefined) {
    return {
      size: toUnitSize(sizeInBytes, unit),
      unit,
    };
  }

  for (const sizeUnit of sizeUnits) {
    if (toUnitSize(sizeInBytes, sizeUnit) >= 1 || sizeUnit === "KB") {
      return {
        size: toUnitSize(sizeInBytes, sizeUnit),
        unit: sizeUnit,
      };
    }
  }

  return {
    size: toUnitSize(sizeInBytes, "KB"),
    unit: "KB" as const,
  };
};

export const formattedFileSize = ({
  sizeInBytes,
  unit,
  maximumFractionDigits = 2,
}: {
  sizeInBytes: number;
  unit?: UnitType;
  maximumFractionDigits?: number;
}) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });

  if (unit !== undefined) {
    return `${formatter.format(toUnitSize(sizeInBytes, unit))}${unit}`;
  }

  const fileSize = parseFileSize({ sizeInBytes });

  return `${formatter.format(fileSize.size)}${fileSize.unit}`;
};
